import { defineMessage } from 'react-intl';

export const emptyCommonI18n = {
  articles: defineMessage({
    id: 'common:empty.articles',
    defaultMessage: 'No articles'
  }),
  cancelledBookings: defineMessage({
    id: 'common:empty.cancelled-bookings',
    defaultMessage: 'No cancelled bookings'
  }),
  bookings: defineMessage({
    id: 'common:empty.bookings',
    defaultMessage: 'No bookings'
  }),
  comments: defineMessage({
    id: 'common:empty.comments',
    defaultMessage: 'No comments'
  }),
  classes: defineMessage({
    id: 'common:empty.classes',
    defaultMessage: 'No classes'
  }),
  instructors: defineMessage({
    id: 'common:empty.instructors',
    defaultMessage: 'No instructors'
  }),
  lessons: defineMessage({
    id: 'common:empty.lessons',
    defaultMessage: 'No lessons'
  }),
  lessonsBetweenDates: defineMessage({
    id: 'common:empty.lessons-in-range',
    defaultMessage: 'No lessons from {startDate} to {endDate}'
  }),
  pastBookings: defineMessage({
    id: 'common:empty.past-bookings',
    defaultMessage: 'No past bookings'
  }),
  payments: defineMessage({
    id: 'common:empty.payments',
    defaultMessage: 'No payments'
  }),
  paymentMethods: defineMessage({
    id: 'common:empty.payment-methods',
    defaultMessage: 'No payment methods'
  }),
  posts: defineMessage({
    id: 'common:empty.posts',
    defaultMessage: 'No posts'
  }),
  reviews: defineMessage({
    id: 'common:empty.reviews',
    defaultMessage: 'No reviews'
  }),
  searchResults: defineMessage({
    id: 'common:empty.search-results',
    defaultMessage: `No results`
  }),
  searchResultsPolite: defineMessage({
    id: 'common:empty.search-results-polite',
    defaultMessage: `Sorry, we couldn't find any results`
  }),
  schools: defineMessage({
    id: 'common:empty.schools',
    defaultMessage: 'No schools'
  }),
  upcomingBookings: defineMessage({
    id: 'common:empty.upcoming-bookings',
    defaultMessage: 'No upcoming bookings'
  }),
  venues: defineMessage({
    id: 'common:empty.venues',
    defaultMessage: 'No venues'
  })
};
